/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-toggle-microphone': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M14.375 8.75v1.875a4.375 4.375 0 11-8.75 0V8.75h-1.25v1.875a5.625 5.625 0 005 5.587V17.5h-2.5v1.25h6.25V17.5h-2.5v-1.288a5.625 5.625 0 005-5.587V8.75h-1.25zm-4.375 5c1.726 0 3.125-1.4 3.125-3.125v-6.25a3.125 3.125 0 00-6.25 0v6.25c0 1.726 1.4 3.125 3.125 3.125zM8.125 4.375a1.875 1.875 0 113.75 0v6.25a1.875 1.875 0 01-3.75 0v-6.25z"/>'
  }
})
